// Pure input primitive - no form/business logic
import { forwardRef, type InputHTMLAttributes } from 'react';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
  inputSize?: 'xs' | 'sm' | 'md' | 'lg';
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ error, inputSize = 'md', className = '', ...props }, ref) => {
    const sizeClass = inputSize !== 'md' ? `input-${inputSize}` : '';
    const errorClass = error ? 'input-error' : '';

    return (
      <input
        ref={ref}
        className={`input w-full rounded-lg bg-[#3A3A3A] border border-white/10 text-[#F9F9F9] placeholder:text-[#CACACA] focus:outline-none focus:border-white/20 ${sizeClass} ${errorClass} ${className}`.trim()}
        {...props}
      />
    );
  }
);

Input.displayName = 'Input';
